import { css } from '@emotion/react';
export const createDefaultsAndCustomTypedCSS = (csses) => ({ customCSS: css ``, defaultsCSS: css ``, ...csses });
